var exports = {
  "LL": "LexicalMessageComposer.module__editable___czd6cT",
  "h5": "LexicalMessageComposer.module__richInputHost___czd6cT",
  "I8": "LexicalMessageComposer.module__formSize___czd6cT",
  "FY": "LexicalMessageComposer.module__paragraph___czd6cT",
  "qf": "LexicalMessageComposer.module__placeholder___czd6cT",
  "xL": "LexicalMessageComposer.module__marker___czd6cT",
  "_u": "LexicalMessageComposer.module__blockquoteLine___czd6cT",
  "iU": "LexicalMessageComposer.module__blockquoteMarker___czd6cT",
  "Cr": "LexicalMessageComposer.module__bold___czd6cT",
  "TN": "LexicalMessageComposer.module__italic___czd6cT",
  "V1": "LexicalMessageComposer.module__underline___czd6cT",
  "ZN": "LexicalMessageComposer.module__strike___czd6cT",
  "aY": "LexicalMessageComposer.module__code___czd6cT",
  "Po": "LexicalMessageComposer.module__mentionHost___czd6cT",
  "ZJ": "LexicalMessageComposer.module__emojiHost___czd6cT",
  "G5": "LexicalMessageComposer.module__command___czd6cT",
  "Gx": "LexicalMessageComposer.module__slashSlot___czd6cT",
  "Pe": "LexicalMessageComposer.module__slashSlotPlaceholder___czd6cT",
  "ZW": "LexicalMessageComposer.module__slashSlotSeparator___czd6cT",
  "Q$": "LexicalMessageComposer.module__optionalHint___czd6cT",
};

module.exports = exports;
